import { render, staticRenderFns } from "./my-info.vue?vue&type=template&id=50fb0ba7"
import script from "./my-info.vue?vue&type=script&lang=js"
export * from "./my-info.vue?vue&type=script&lang=js"
import style0 from "./my-info.vue?vue&type=style&index=0&id=50fb0ba7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports